import React from 'react'

function Card({img}) {
  return (
    <div>
        <img src={img} alt="err" width={'95%'}/>
    </div>
  )
}

export default Card